
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import ChatWidget from "./components/ChatWidget/ChatWidget";
import tokenMonitor from "./services/tokenMonitor";
import { AuthProvider } from "./contexts/AuthContext";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import 'react-toastify/dist/ReactToastify.css';

import UserLayout from "layouts/User.js";
import AdminLayout from "layouts/Admin.js";
import Login from "views/Login";
import HomeSignup from "views/Signup";
import NewLogin from "views/NewLogin";
import AuthService from "services/auth.service";
import Check from "./Check";







const root = ReactDOM.createRoot(document.getElementById("root"));

// Start token monitoring
tokenMonitor.start();

root.render(
  
  <BrowserRouter>
  <AuthProvider>
    <ChatWidget />
    <Routes>
      
      <Route path="/user/*" element={<Check> <UserLayout /> </Check>} />
      <Route path="/admin/*" element={<Check> <AdminLayout /> </Check>} />
      {/* <Route path="/" element={<Navigate to="/admin/dashboard" replace />} /> */}
      {/* <Route path="/login" element={<Login />} />
      <Route path="/SignUp" element={<HomeSignup />} /> */}
      
      <Route path="/" element={<NewLogin />} />
      
    </Routes>
    </AuthProvider>
  </BrowserRouter>
  
);
